module.exports = __webpack_public_path__ + "BANNER.png?d3e046f915bea51d509cb3f51bdb4646";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/BANNER.png
// module id = 160
// module chunks = 0